<!--This component will allow you to use dynamic Year Make Model Trim drop downs to select one vehicle and get the MSIS Vehicle ID-->
<template>
  <b-row >
    <b-col md="2"  class="p-2">
      <label for="selyear">Year</label>
      <b-form-select class="form-control"  id="selyear" v-model="selectvehicle.Year" :options="yearsList" @change="onYearChanged($event)" />
    </b-col>
    <b-col md="3"  class="p-2" > 
      <label for="selMake">Make</label>
      <b-form-select  class="form-control" id="selMake" v-model="selectvehicle.MakeId" :options="makesList" @change="onMakeChanged($event)" />
    </b-col>
    <b-col md="3"  class="p-2" >
      <label for="selModel">Model</label>
      <b-form-select  class="form-control" id="selModel" v-model="selectvehicle.ModelId" :options="modelsList" @change="onModelChanged($event)" />
    </b-col>
    <b-col  md="4"  class="p-2" >
      <label for="selTrim">Trim</label>
      <b-form-select  class="form-control" id="selTrim" v-model="selectvehicle.NewUsedId" :options="trimsList" @change="onTrimChanged($event)" />
    </b-col>
    </b-row>
</template>

<script>

  import axios from 'axios'
  import loading from 'vue-full-loading'
  import { isUndefined, isNullOrUndefined, isNull } from 'util'

  export default {
    components: {
      loading
    },
    created() {
      axios.all([
        axios.get('/api/quotepolicy/getyears?isnew=1&year=0&make=0&model=0')
      ])
        .then(axios.spread((newYearsRes, usedYearsRes) => {
          this.list_year_new = newYearsRes.data.filter(x => (x.id > 0)).map(x => { return { text: x.name, value: x.id } })
          this.boolLoading = false
          this.yearsList = this.list_year_new
        }))
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    data() {
      return {
        errMsg: '',
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        showHeader: true,
        boolLoading: false,
        txtLoading: 'Loading...',
        selectvehicle: {
          IsNew: 1, Year: null, VIN: null
        },
        selectedVehicleID: null,
        list_year_new: [],
        list_year_used: [],
        yearsList: [],
        makesList: [],
        modelsList: [],
        trimsList: [],
        deductions: [{
          key: 'Name', label: 'Deductions', thClass: 'h4 card-title table-borderless'
        }],
        multipleVehicleMatch: []
      }
    },
    methods: {
      onYearChanged(arg) {
        var self = this
        if (self.selectvehicle.IsNew < 0) {
          alert('Select a type')
          return
        }

        self.boolLoading = true
        self.vehicle = null
        self.selectvehicle.MakeId = null
        self.selectvehicle.ModelId = null
        self.selectvehicle.NewUsedId = null
        self.multipleVehicleMatch = []
        axios.get('/api/mscope/getmakes?isnew=' + self.selectvehicle.IsNew + '&year=' + arg + '&make=0&model=0')
          .then(response => {
            self.makesList = response.data.map(x => { return { text: x.name, value: x.id } })
            self.boolLoading = false
          })
          .catch(error => {
            self.SetErrorMsg(error, 'getting')
          })
      },
      onMakeChanged(arg) {
        var self = this
        if (self.selectvehicle.IsNew < 0 || isNullOrUndefined(self.selectvehicle.Year)) {
          alert('Select a type and year')
          return
        }

        self.boolLoading = true
        self.vehicle = null
        self.selectvehicle.ModelId = null
        self.selectvehicle.NewUsedId = null
        self.multipleVehicleMatch = []
        axios.get('/api/mscope/getmodels?isnew=' + self.selectvehicle.IsNew + '&year=' + self.selectvehicle.Year + '&make=' + arg + '&model=0')
          .then(response => {
            self.modelsList = response.data.map(x => { return { text: x.name, value: x.id } })
            self.boolLoading = false
          })
          .catch(error => {
            self.SetErrorMsg(error, 'getting')
          })
      },
      onModelChanged(arg) {
        var self = this
        self.boolLoading = true
        self.vehicle = null
        self.selectvehicle.NewUsedId = null
        self.multipleVehicleMatch = []
        axios.get('/api/mscope/gettrims?isnew=' + self.selectvehicle.IsNew + '&year=' + self.selectvehicle.Year + '&make=' + self.selectvehicle.MakeId + '&model=' + arg)
          .then(response => {
            self.trimsList = response.data.map(x => { return { text: x.name, value: x.id } })
            self.boolLoading = false
          })
          .catch(error => {
            self.SetErrorMsg(error, 'getting')
          })
      },
      onTrimChanged(arg) {
        var self = this
        self.boolLoading = true
        self.vehicle = null
        self.multipleVehicleMatch = []
        self.selectedVehicleID = arg 
        self.$emit('clicked', 'true')
       },
        
      SetErrorMsg(error, action) {
        var self = this

        if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { self.$router.push('/login') }

        self.boolLoading = false

        self.errMsg = 'There was an error ' + action + ' your changes : '
        if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
          self.errMsg = self.errMsg + error.response.statusText
        } else {
          self.errMsg = self.errMsg + error
        }

        self.dismissibleType = 'danger'
        self.showDismissibleAlert = true

        if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { self.errMsg = error.response.statusText.replace('403.1', '') }
      }
    },
    mounted() {
      // boolLoading must be set to false on data() binding so that mount hooks the change
      this.boolLoading = true
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/YMMTLookup.vue